import React from 'react';

var decorateActionMenuChildren = function decorateActionMenuChildren(children, handleClose) {
    var childList = null;

    if (children) {
        childList = React.Children.toArray(children).map(function (child) {
            if (!React.isValidElement(child)) {
                return child;
            }

            return React.cloneElement(child, {
                handleClose: handleClose
            });
        });
    }

    return childList;
};

export default decorateActionMenuChildren;